export class Activity {
    uid: string;
    description: string;
    companyUID: string;
    status: ActivityStatus;
    sentUserUID: string;
    creationDate: number;
    finishDate: number;
    expirationDate: number;
    expirationDateString: string;
    category: ActivityCategory;
}

export enum ActivityStatus {
    TODO = 1,
    EXPIRED = 2,
    DONE = 3
}

export enum ActivityCategory {
    EMAIL = 1,
    HABILITATION = 2,
    CALL = 3,
    TRADING_FLOOR = 4,
    PROPOSAL = 5,
    MEETING = 6,
    VISIT = 7
}



// WEBPACK FOOTER //
// ./src/app/model/activity.ts